"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _reactComponents = require("@cimpress/react-components");

var _TextField = _interopRequireDefault(require("@cimpress/react-components/lib/TextField"));

var _Tooltip = _interopRequireDefault(require("@cimpress/react-components/lib/Tooltip"));

var _every2 = _interopRequireDefault(require("lodash/every"));

var _i18nIsoCountries = _interopRequireDefault(require("i18n-iso-countries"));

var _map = _interopRequireDefault(require("lodash/map"));

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

var _ConfigShippingContainer = _interopRequireDefault(require("../ShippingConfiguration/ConfigShippingContainer"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-left: auto;\n  margin-right: auto;\n  width: 112px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var positiveIntegerRegex = /^\d*[1-9]+\d*$/;
var initialState = {
  input: '',
  quantities: [],
  showPopover: false,
  canSubmit: false,
  isValid: true
};
var customStyle = (0, _emotion.css)(_templateObject());
var tooltipStyle = {
  maxWidth: '350px'
};

var CustomQuantityEntry =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CustomQuantityEntry, _Component);

  function CustomQuantityEntry() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CustomQuantityEntry);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CustomQuantityEntry)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = (0, _objectSpread2.default)({}, initialState, {
      open: false
    });

    _this.onInputChange = function (e) {
      var input = e.target.value;
      var values = input.split(',').map(function (x) {
        return x.trim();
      }).filter(function (x) {
        return x;
      });
      var quantities = values.map(function (value) {
        return parseInt(value, 10);
      });
      var isValid = (0, _every2.default)(values, function (value) {
        return positiveIntegerRegex.test(value);
      });
      var canSubmit = isValid && values.length;

      _this.setState({
        input: input,
        quantities: quantities,
        canSubmit: canSubmit,
        isValid: isValid
      });
    };

    _this.getDefaultCountryOptions = function () {
      return (0, _map.default)(_i18nIsoCountries.default.getNames('en'), function (countryName) {
        var countryCode = _i18nIsoCountries.default.getAlpha2Code(countryName, 'en');

        return {
          value: countryCode,
          label: "".concat(countryName, " (").concat(countryCode, ")")
        };
      });
    };

    _this.togglePopover = function () {
      return _this.setState({
        showPopover: !_this.state.showPopover
      });
    };

    _this.addQuantities = function (e) {
      e.preventDefault();
      var _this$state = _this.state,
          quantities = _this$state.quantities,
          isValid = _this$state.isValid;

      if (isValid) {
        _this.props.addQuantities(quantities);
      }

      _this.setState((0, _objectSpread2.default)({}, initialState));
    };

    _this.openModal = function () {
      _this.setState({
        open: true
      });
    };

    _this.closeModal = function () {
      _this.setState({
        open: false
      });
    };

    return _this;
  }

  (0, _createClass2.default)(CustomQuantityEntry, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          input = _this$state2.input,
          showPopover = _this$state2.showPopover,
          canSubmit = _this$state2.canSubmit,
          isValid = _this$state2.isValid,
          open = _this$state2.open;
      var _this$props = this.props,
          onShippingSubmit = _this$props.onShippingSubmit,
          shipmentConfiguration = _this$props.shipmentConfiguration;
      return _react.default.createElement("th", {
        className: "pricing-cell quantity-header"
      }, _react.default.createElement("div", {
        className: customStyle
      }, _react.default.createElement(_Tooltip.default, {
        tooltipStyle: tooltipStyle,
        direction: "bottom",
        variety: "popover",
        show: showPopover,
        onClickOutside: showPopover ? this.togglePopover : null,
        contents: _react.default.createElement("form", {
          onSubmit: this.addQuantities
        }, _react.default.createElement(_TextField.default, {
          label: "Enter quantity",
          value: input,
          onChange: this.onInputChange,
          rightAddon: _react.default.createElement("button", {
            className: "btn btn-primary",
            disabled: !canSubmit
          }, "Add")
        }), _react.default.createElement("div", {
          className: "small"
        }, "To enter multiple values, separate them with a comma."), !isValid ? _react.default.createElement("div", {
          className: "text-danger small"
        }, _react.default.createElement("i", {
          className: "fa fa-exclamation-triangle text-danger"
        }), " Please only enter positive integers, commas, or spaces.") : null)
      }, _react.default.createElement(_Tooltip.default, {
        direction: "top",
        contents: "Add Quantity"
      }, _react.default.createElement("button", {
        className: "clickable pricing-table__button",
        onClick: this.togglePopover
      }, _react.default.createElement(_reactComponents.Icon, {
        color: colors.teal.base,
        name: "add-circle-1",
        size: "2x"
      })))), _react.default.createElement(_Tooltip.default, {
        direction: "top",
        contents: "Shipment Configuration"
      }, _react.default.createElement("button", {
        className: "clickable pricing-table__button",
        onClick: this.openModal
      }, _react.default.createElement(_reactComponents.Icon, {
        color: colors.teal.base,
        name: "truck-2-l",
        size: "2x"
      }))), _react.default.createElement("div", null, _react.default.createElement(_ConfigShippingContainer.default, {
        onShippingSubmit: onShippingSubmit,
        deliveryLocations: this.getDefaultCountryOptions(),
        shippingConfig: shipmentConfiguration,
        open: open,
        closeModal: this.closeModal
      })), _react.default.createElement(_Tooltip.default, {
        direction: "top",
        contents: "Reset Quantities"
      }, _react.default.createElement("button", {
        className: "clickable pricing-table__button",
        onClick: this.props.resetQuantities
      }, _react.default.createElement(_reactComponents.Icon, {
        color: colors.teal.base,
        name: "undo-l",
        size: "2x"
      })))));
    }
  }]);
  return CustomQuantityEntry;
}(_react.Component);

exports.default = CustomQuantityEntry;